function reducer(state = [], action) {    
    switch (action.type) {
        case 'COACHES/ALL/SET':
            return action.coaches;
        case 'COACHES/CLEAR':
            return null;        
        default:
            return state;
    }
}

export default reducer;
